import { EntityFormatter } from "@comparaonline/ui-offer-entity-formatter";
import Typography from "@material-ui/core/Typography";
import React from "react";

import { ListFormat } from "./ListFormat";
import { INameValueProps } from "./types";

const isListType = (type: string) => type === "list";

export const NameValue: React.FC<INameValueProps> = ({ name, value, type, format }) => (
  <Typography variant="body1">
    <span>{name}</span>
    {value && (
      <>
        {": "}
        {isListType(type) ? (
          <ListFormat value={value as string[]} />
        ) : (
          <EntityFormatter format={format} type={type} value={value} />
        )}
      </>
    )}
  </Typography>
);
